import { getInventoryTypeForPublicationState } from './get-inventory-type-for-publication-state';

/**
 * Transform map of publication states to inventory types.
 * Publication states can be more than one, f.e. - ['USED', 'NEW_USED'].
 * @param {Array} publicationStates
 * @return {Array}
 */
export function getInventoryTypesForPublicationStates(publicationStates) {
  return publicationStates.map(pubState => getInventoryTypeForPublicationState(pubState));
}
